"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function Loader(_a) {
    var _b = _a.width, width = _b === void 0 ? "100%" : _b, _c = _a.height, height = _c === void 0 ? "20px" : _c, _d = _a.className, className = _d === void 0 ? "" : _d;
    return (0, jsx_runtime_1.jsx)(Skeleton_1.default, { className: "twap-loader ".concat(className), animation: "wave", width: width, height: height, style: { opacity: 0.7 } });
}
exports.default = Loader;
